import React from 'react';
import { IoIosStar } from '@react-icons/all-files/io/IoIosStar';
var Small = function (_a) {
    var className = _a.className, rating = _a.rating, totalCount = _a.totalCount;
    var handleScrollToReviews = function (e) {
        e.preventDefault();
        var reviewsElement = document.getElementById('large-reviews-widget');
        if (reviewsElement) {
            var elementPosition = reviewsElement.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - 90;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };
    return (React.createElement("div", { className: "dui-flex dui-items-center dui-gap-2 ".concat(className) },
        React.createElement("h2", { className: 'dui-font-body dui-flex dui-items-start dui-gap-1 dui-shrink-0 !dui-font-normal' },
            React.createElement(IoIosStar, null),
            rating),
        totalCount && (React.createElement("a", { href: "#large-reviews-widget", onClick: handleScrollToReviews },
            React.createElement("p", { className: 'dui-text-sm dui-text-gray-400 dui-underline dui-underline-offset-2' },
                "from ",
                React.createElement("strong", null, totalCount),
                " reviews")))));
};
export default Small;
